export class LandingPageSearchModel
{
    date:string;
    toCountryId:number;
    toPortIds:number[];
    fromCountryId:number;
    fromPortIds:number[];
    isSearch:boolean;
    searchBy:number |null |undefined;
    isCountrySearch:any |null;
}